import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="advance-number"
export default class extends Controller {
  static targets = ["automatic", "custom", "input"]

  reveal(event) {
    this.automaticTarget.classList.add("hidden")
    this.customTarget.classList.remove("hidden")
    event.currentTarget.setAttribute("aria-expanded", "true")
    this.inputTarget.disabled = false
    this.inputTarget.focus()
  }
}
